// src/components/layout/Layout.jsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      {/* <Footer />
      <ModalManager />
      <Notification />
      <ScrollIndicator /> */}
    </div>
  );
};

export default Layout;